import { Link } from 'react-router-dom';

const ASSETS = {
  full: '/mymusicia-logo-full.png',
  emblem: '/mymusicia-emblem.png',
};

// Official MyMusic IA logo. Never redraw/recreate: render the provided asset
// as-is with object-contain to preserve its ratio, geometry and colors.
export function Logo({ variant = 'full', className = '', linkClassName = '', to = '/' }) {
  return (
    <Link to={to} className={`inline-flex items-center ${linkClassName}`} data-testid="brand-logo" aria-label="MyMusic IA">
      <img
        src={ASSETS[variant] || ASSETS.full}
        alt="MyMusic IA — Le studio de ton imagination"
        className={`w-auto object-contain ${className}`}
        draggable={false}
      />
    </Link>
  );
}
